/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ unit: NonNullable<unknown> }} Exercise_Sheet_How_Bodyweight_PlusInputs */

const en_us2_exercise_sheet_how_bodyweight_plus = /** @type {(inputs: Exercise_Sheet_How_Bodyweight_PlusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Log only the added weight, in the “${i?.unit}” field; your body weight is counted in.`)
};

const pt_br2_exercise_sheet_how_bodyweight_plus = /** @type {(inputs: Exercise_Sheet_How_Bodyweight_PlusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Registre só o peso extra, no campo “${i?.unit}”; seu peso corporal entra na conta.`)
};

const es_419_exercise_sheet_how_bodyweight_plus = /** @type {(inputs: Exercise_Sheet_How_Bodyweight_PlusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Registra solo el peso extra, en el campo “${i?.unit}”; tu peso corporal entra en la cuenta.`)
};

const pt_pt2_exercise_sheet_how_bodyweight_plus = /** @type {(inputs: Exercise_Sheet_How_Bodyweight_PlusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Regista só o peso extra, no campo “${i?.unit}”; o teu peso corporal entra na conta.`)
};

const fr_fr2_exercise_sheet_how_bodyweight_plus = /** @type {(inputs: Exercise_Sheet_How_Bodyweight_PlusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Note seulement la charge ajoutée, dans le champ « ${i?.unit} » ; ton poids de corps est pris en compte.`)
};

const de_de2_exercise_sheet_how_bodyweight_plus = /** @type {(inputs: Exercise_Sheet_How_Bodyweight_PlusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Trag nur das Zusatzgewicht im Feld „${i?.unit}“ ein; dein Körpergewicht wird mitgerechnet.`)
};

const it_it2_exercise_sheet_how_bodyweight_plus = /** @type {(inputs: Exercise_Sheet_How_Bodyweight_PlusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Registra solo il peso aggiunto, nel campo “${i?.unit}”; il tuo peso corporeo viene incluso nel conto.`)
};

/**
* | output |
* | --- |
* | "Log only the added weight, in the “{unit}” field; your body weight is counted in." |
*
* @param {Exercise_Sheet_How_Bodyweight_PlusInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_how_bodyweight_plus = /** @type {((inputs: Exercise_Sheet_How_Bodyweight_PlusInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_How_Bodyweight_PlusInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_how_bodyweight_plus(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_how_bodyweight_plus(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_how_bodyweight_plus(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_how_bodyweight_plus(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_how_bodyweight_plus(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_how_bodyweight_plus(inputs)
	return en_us2_exercise_sheet_how_bodyweight_plus(inputs)
});
export { exercise_sheet_how_bodyweight_plus as "exercise-sheet.how_bodyweight_plus" }